import styled, { css } from 'styled-components';

export const TopScorersWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${props => props.theme.colors.lightGray};
  
  ${props => props.isGazzanet && css`
    border-bottom: none;
  `}
`;



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/TopScorersWidgetGazzanet/styles.js